import { EVENT_CEILING_TIER_DEFINITIONS } from './credit';
/**
 * Kurum paketi. pg ENUM DEĞİLDİR: `organizations.plan` varchar(16) +
 * `ck_organizations_plan` CHECK ile saklanır (backlog §5).
 *
 * ATIL SÜTUN (kurum satışla açılır planı · V16): tavanın anahtarı artık kurum
 * paketi DEĞİL, etkinliğin kredi türünden türeyen kademedir (`EventCeilingTier`).
 * Sütun ve `organization_plan_audit` tetikleyicisi şemada kalır (migration'lar
 * dondu) ama hiçbir kod yolu onu OKUMAZ (`plan-column-readers.guard.spec`).
 * Liste yalnız okuma ucunun geriye uyumlu `plan` alanı ve bugünkü web/mobil
 * paket ekranı için durur.
 * TODO(tech-debt): Story E2/E3 paket ekranını kredi modeline geçirince
 * `ORGANIZATION_PLANS` ve `PLAN_ENTITLEMENTS` kalkar.
 */
export const ORGANIZATION_PLANS = ['free', 'pro', 'enterprise'];
/**
 * PAKET KATMANININ KARAR TABLOSU (Faz 4 · Story 21.1 → kredi modeli · Story E1).
 *
 * "Bölümden bölüme değişen bir sınır, sınır değildir": tavan SAYISI
 * `credit.ts`teki kademe tablosundadır; burada kademeye bağlı yetenekler ve
 * %80 eşiği eklenir. Hiçbir modül kendi eşiğini yeniden yazmaz.
 *
 * KIRMIZI ÇİZGİLER (backlog §4 — burada YAPISAL olarak korunur):
 * - KÇ 2: anahtar kümesi KAPALIDIR ve hiçbiri görünürlük davranışını değiştirmez.
 *   "Tüm katılımcıları göster" diye bir yetenek YOKTUR ve eklenemez.
 * - KÇ 3: cüzdan, kart ve kişisel dışa aktarım anahtarı YOKTUR — pakete
 *   bağlanamazlar, çünkü bağlanacak bir anahtar tanımlı değildir.
 * - SERT SINIR (V18, kullanıcı kararı 01.10.2026): Faz 4'ün P1 ilkesi ("tavan
 *   katılımcıyı asla cezalandırmaz") bu kararla GEÇERSİZDİR. Tavana ulaşılınca
 *   kayıt, davet kabulü ve başvuru onayı reddedilir (`isRegistrationBlockedByCeiling`).
 *   P2 korunur: check-in tavandan HİÇ etkilenmez.
 */
/**
 * Tavana bağlı yeteneklerin KAPALI kümesi. Yeni bir anahtar eklemek bir ürün
 * kararıdır (hangi acı, kimde, neden) — sessizce büyümesin diye tek satırda
 * gerekçesiyle durur.
 */
export const PLAN_CAPABILITIES = [
    /** Yeni davet gönderimi — büyümeyi organizatör tetikler, acı orada doğrudur. */
    'invitations.send',
    /** Toplu katılımcı işlemi — 100+ kaydı toplu yönetmek Pro'nun kendisidir. */
    'attendees.bulk',
    /** Analitik kırılımları — KPI sayıları açık kalır, kovalar kilitlenir. */
    'analytics.breakdowns',
];
function tierEntitlement(tier) {
    const definition = EVENT_CEILING_TIER_DEFINITIONS[tier];
    return {
        attendeeCeiling: definition.attendeeCeiling,
        invitationCeiling: definition.invitationCeiling,
        teamMemberCeiling: definition.teamMemberCeiling,
        ceilingBoundCapabilities: PLAN_CAPABILITIES,
    };
}
/** Kademe başına yetkilendirme — sayılar `EVENT_CEILING_TIER_DEFINITIONS`ten TÜRER. */
export const CEILING_TIER_ENTITLEMENTS = {
    trial: tierEntitlement('trial'),
    standard: tierEntitlement('standard'),
    unlimited: tierEntitlement('unlimited'),
};
/**
 * GERİYE UYUMLU `plan` ALANI: okuma ucunun ve hata gövdesinin `plan` alanı adı
 * ve tipiyle KALIR (E1: "istemci kırılmaz"); değeri kademeden türer.
 * TODO(tech-debt): Story E2/E3 ile kalkar.
 */
export const LEGACY_PLAN_FOR_TIER = {
    trial: 'free',
    standard: 'pro',
    unlimited: 'enterprise',
};
/** Bugünkü paket ekranı için: sayılar kademe tablosundan gelir, ikinci kez yazılmaz. */
export const PLAN_ENTITLEMENTS = {
    free: CEILING_TIER_ENTITLEMENTS.trial,
    pro: CEILING_TIER_ENTITLEMENTS.standard,
    enterprise: CEILING_TIER_ENTITLEMENTS.unlimited,
};
/*
 * PAKET KARTLARININ FİYATI (`PLAN_PRICING`, TRY) KALKTI (para kırmızı çizgisi,
 * 30.10.2026). Hiçbir ekran okumuyordu ama bu paket her istemcinin JS paketine
 * girdiği için eski tutarlar kamu sayfalarından okunabiliyordu. Fiyat yalnız
 * sunucudadır (`credit-price-client-leak.guard.spec`).
 */
/** Şeridin çıktığı eşik (backlog §3.3 · iş modeli tetikleyici 1). */
export const PLAN_USAGE_WARNING_RATIO = 0.8;
/**
 * `ok` → %79 ve altı · `warning` → %80 ile tavanın bir altı · `exceeded` →
 * TAVANDA ya da üstünde.
 *
 * `exceeded` ADI BİLİNÇLİ KALDI (web ve mobil `status === 'exceeded'` okur,
 * istemci sözleşmesi kırılmasın), ANLAMI "tavan doldu"dur. Sert sınır (V18-a)
 * sayıyı tavanda tuttuğu için "tavanın üstü" eşiği pratikte HİÇ oluşmaz; kilit
 * `>` ile açılsaydı 100/100'deki organizatör kabul edilemeyecek davet
 * gönderebilirdi. V18-d: büyüme kilitleri TAVANDA kilitli kalır.
 */
export const PLAN_USAGE_STATUSES = ['ok', 'warning', 'exceeded'];
/**
 * Tavan durumunun TEK hesabı. Saf fonksiyondur: sunucu, migration ve (Blok 28)
 * arayüz aynı sonucu üretir; "şu ekranda %80, bu ekranda %79" olmaz.
 */
export function evaluatePlanUsage(input) {
    const entitlement = CEILING_TIER_ENTITLEMENTS[input.tier];
    const plan = LEGACY_PLAN_FOR_TIER[input.tier];
    const ceiling = entitlement.attendeeCeiling;
    const used = Math.max(input.attendeeCount, 0);
    const grandfatherActive = input.grandfatheredUntil !== null && input.grandfatheredUntil.getTime() > input.now.getTime();
    if (ceiling === null) {
        return {
            tier: input.tier,
            plan,
            ceiling: null,
            used,
            remaining: null,
            usedPercent: null,
            status: 'ok',
            grandfatheredUntil: input.grandfatheredUntil,
            grandfatherActive,
            lockedCapabilities: [],
        };
    }
    // TAVANDA KİLİT (V18-d): kayıt kapısıyla (`isRegistrationBlockedByCeiling`)
    // AYNI eşik. İkisi ayrışırsa `plan.spec` eşik eşleşmesi vakası kırılır.
    const exceeded = used >= ceiling;
    const usedPercent = Math.round((used / ceiling) * 100);
    const status = exceeded
        ? 'exceeded'
        : used >= Math.ceil(ceiling * PLAN_USAGE_WARNING_RATIO)
            ? 'warning'
            : 'ok';
    return {
        tier: input.tier,
        plan,
        ceiling,
        used,
        remaining: Math.max(ceiling - used, 0),
        usedPercent,
        status,
        grandfatheredUntil: input.grandfatheredUntil,
        grandfatherActive,
        // MUAFİYET: kilit uygulanmaz ama DURUM gizlenmez — şerit "aştın, ama bu
        // etkinlik mevcut kurala tabi değil" diyebilsin (backlog §3.3).
        lockedCapabilities: exceeded && !grandfatherActive ? entitlement.ceilingBoundCapabilities : [],
    };
}
export function isPlanCapabilityLocked(usage, capability) {
    return usage.lockedCapabilities.includes(capability);
}
/**
 * SERT SINIR (V18-a): yeni katılım satırı reddedilir mi. `countedBefore`
 * ekleme ÖNCESİ sunucu sayımıdır (organizatörün otomatik kaydı hariç,
 * `countedAttendanceSql`). Davranış kademe tablosundan okunur; `soft` kademe
 * hiçbir zaman reddetmez.
 */
export function isRegistrationBlockedByCeiling(tier, countedBefore) {
    const definition = EVENT_CEILING_TIER_DEFINITIONS[tier];
    if (definition.attendeeCeiling === null || definition.behavior !== 'hard')
        return false;
    return countedBefore >= definition.attendeeCeiling;
}
/**
 * KAYIT KAPANANA KADAR KALAN YER (T5 tech-lead · tavan metinleri).
 *
 * Sert sınırda (kullanıcı kararı 01.10.2026) yeni kayıt, davet kabulü ve
 * başvuru onayı sınırda KAPANIR; kapasite 150, sınır 100 olan etkinlikte 100
 * kayıtta kalan yer 50 değil 0'dır: `min(kapasite, sınır) - kayıt`.
 *
 * `quotaRemaining` kapasitenin (ya da bilet kontenjanının) bıraktığı yerdir;
 * `null` = sınırsız. Sınır yalnız `hard` kademede, muafiyet aktif DEĞİLKEN
 * uygulanır (`isRegistrationBlockedByCeiling` ile aynı koşul). Paket kaydı
 * bilinmiyorsa (`ceiling === null`) kilit uydurulmaz, kapasite yazılır.
 * Sunucu (analitik `remainingCapacity`) ve istemciler (davet formu) bu tek
 * hesabı okur: `remaining-seats.guard.spec.ts`.
 */
export function seatsLeftUnderCeiling(quotaRemaining, ceiling) {
    const enforced = ceiling !== null &&
        !ceiling.grandfatherActive &&
        ceiling.remaining !== null &&
        EVENT_CEILING_TIER_DEFINITIONS[ceiling.tier]?.behavior === 'hard';
    const ceilingRemaining = enforced ? Math.max(ceiling.remaining ?? 0, 0) : null;
    if (quotaRemaining === null)
        return ceilingRemaining;
    if (ceilingRemaining === null)
        return Math.max(quotaRemaining, 0);
    return Math.max(Math.min(quotaRemaining, ceilingRemaining), 0);
}
export function hasReachedCeilingWarning(tier, countedAfter) {
    const ceiling = EVENT_CEILING_TIER_DEFINITIONS[tier].attendeeCeiling;
    if (ceiling === null)
        return false;
    return countedAfter >= Math.ceil(ceiling * PLAN_USAGE_WARNING_RATIO);
}
//# sourceMappingURL=plan.js.map